/**
 * @fileoverview DELETE handler for the "/apps/app_groups/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupsAppGroupIdCacheKeys } from "./constants";
import type { DeleteAppsAppGroupsAppGroupIdProps } from "./types";

export const deleteAppsAppGroupsAppGroupId = reactQueryMutationAdapter(
  appsAppGroupsAppGroupIdCacheKeys,
  ({ appGroupId }: DeleteAppsAppGroupsAppGroupIdProps): Promise<void> => {
    return fetch(`/apps/app_groups/${appGroupId}`, "DELETE", {});
  }
);
